<template>
  <div class="cenario-container">
    <div class="cenario-bloco">
      <h3>TIPO DA OPERAÇÃO <span>*</span></h3>
      <CenarioInput
        placeholder="Selecione o Tipo da Operação"
        nome="tipoOperacao"
        :validaCampos="validaCampos"
        :exibeValidacao="exibeValidacao"
        :model="tipoOperacao"
        :options="tipoOperacaoOptions.map(p => p.label)"
        @update:model="update => (tipoOperacao = update)"
        @selected="update => updateDados(update, 'tipoOperacao', tipoOperacaoOptions)"
      />
    </div>
    <div
      :key="`cenarioOperacaoKey${key}`"
      :class="['cenario-bloco', 'bloco-divisao', { 'bloco-multiplo': numeroCenarios > 1 }]"
    >
      <div
        v-if="
          dadosForm.tipoOperacao == '40' ||
            dadosForm.tipoOperacao == '39' ||
            dadosForm.tipoOperacao == '46'
        "
      >
        <h3>UF ORIGEM <span>*</span></h3>
        <CenarioInput
          placeholder="Selecione um Estado"
          nome="ufOrigem"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :model="ufOrigem"
          :options="
            filtros.estado_origem.valores
              .filter(f => f.value != dadosForm.ufDestino)
              .map(p => p.label)
          "
          @update:model="update => (ufOrigem = update)"
          @selected="update => updateDados(update, 'ufOrigem', filtros.estado_origem.valores)"
        />
      </div>
      <div v-if="dadosForm.tipoOperacao == '41'">
        <h3>PAÍS ORIGEM <span>*</span></h3>
        <CenarioInput
          placeholder="Selecione um País"
          nome="paisOrigem"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :model="paisOrigem"
          :options="filtros.pais_origem.valores.map(p => p.label)"
          @update:model="update => (paisOrigem = update)"
          @selected="update => updateDados(update, 'paisOrigem', filtros.pais_origem.valores)"
        />
      </div>
      <div v-if="dadosForm.tipoOperacao == '40' || dadosForm.tipoOperacao == '41'">
        <h3>UF DESTINO <span>*</span></h3>
        <CenarioInput
          placeholder="Selecione um Estado"
          nome="ufDestino"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :model="ufDestino"
          :options="
            filtros.estado_destino.valores
              .filter(f => f.value != dadosForm.ufOrigem)
              .map(p => p.label)
          "
          @update:model="update => (ufDestino = update)"
          @selected="update => updateDados(update, 'ufDestino', filtros.estado_destino.valores)"
        />
      </div>
      <div v-if="dadosForm.tipoOperacao == '46'">
        <h3>PAÍS DESTINO <span>*</span></h3>
        <CenarioInput
          placeholder="Selecione um País"
          nome="paisDestino"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :model="paisDestino"
          :options="filtros.pais_destino.valores.map(p => p.label)"
          @update:model="update => (paisDestino = update)"
          @selected="update => updateDados(update, 'paisDestino', filtros.pais_destino.valores)"
        />
      </div>
    </div>
    <div v-if="mostraZfm" class="cenario-bloco">
      <h3>
        VERIFICAR TRATAMENTO TRIBUTÁRIO DIFERENCIADO PARA OPERAÇÕES COM A ÁREA DE LIVRE COMÉRCIO E
        AMAZÔNIA OCIDENTAL? <span>*</span>
        <a
          class="question"
          tabindex="-1"
          href="http://www.econeteditora.com.br/links_pagina_inicial/area_especial/suframa/area_especial_suframa_capa.php"
          target="_blank"
        >
          <font-awesome-icon
            class="btn-question"
            v-b-tooltip.hover
            title="Clique para mais informações"
            icon="question-circle"
          />
        </a>
      </h3>
      <CenarioInput
        class="zfm-input"
        placeholder="Selecione"
        nome="zfm"
        :validaCampos="validaCampos"
        :exibeValidacao="exibeValidacao"
        :model="zfm"
        :options="zfmOptions.map(p => p.label)"
        @update:model="update => (zfm = update)"
        @selected="update => updateDados(update, 'zfm', zfmOptions)"
      />
    </div>
  </div>
</template>

<script>
import CenarioInput from "../CenarioInput/CenarioInput.vue";

export default {
  name: "CenarioCorpoOperacao",

  components: { CenarioInput },

  props: {
    exibeValidacao: Boolean,
    numeroCenarios: Number,
    calculaDadosForm: Function,
    dadosForm: Object,
    filtros: Object,
    validaCampos: Object
  },

  data() {
    return {
      key: 0,
      tipoOperacao: "",
      zfm: "",
      ufOrigem: "",
      paisOrigem: "",
      ufDestino: "",
      paisDestino: "",
      tipoOperacaoOptions: [
        { label: "Exportação", value: "46" },
        { label: "Importação", value: "41" },
        { label: "Interestadual", value: "40" },
        { label: "Interna", value: "39" }
      ],
      zfmOptions: [
        { label: "Sim", value: "1" },
        { label: "Não", value: "0" }
      ]
    };
  },

  created() {
    this.carregaDadosForm();
  },

  watch: {
    // REINICIA AS DEPENDÊNCIAS DA OPERAÇÃO
    "dadosForm.tipoOperacao": {
      deep: true,
      handler() {
        // this.$nextTick(() => {
        this.key += 1;
        this.reiniciaDependenciasOperacao();
        // });
      }
    },
    // CARREGA DADOS DO CENÁRIO PARA OS INPUTS
    dadosForm: {
      deep: true,
      handler() {
        this.carregaDadosForm();
      }
    }
  },

  computed: {
    // MOSTRA OU ESCONDE O CAMPO DE ZFM DEPENDENDO DO ESTADO
    mostraZfm() {
      let estadosZfm = ["1", "3", "4", "21", "22"];
      if (
        (estadosZfm.includes(this.dadosForm.ufOrigem) ||
          estadosZfm.includes(this.dadosForm.ufDestino)) &&
        this.dadosForm.tipoOperacao != ""
      ) {
        return true;
      }
      this.zfm = "";
      this.calculaDadosForm("", "zfm");
      return false;
    }
  },

  methods: {
    // ATUALIZA O FORMULÁRIO DE ACORDO COM OS VALORES LOCAIS
    updateDados(update, campo, caminho) {
      this[campo] = update;
      let valor = caminho.find(p => p.label == update);
      this.calculaDadosForm(valor ? valor.value : "", campo);
    },
    // ZERA VALORES QUE SÃO DEPENDENDTES DO TIPO DE OPERAÇÃO
    reiniciaDependenciasOperacao() {
      this.calculaDadosForm("", "ufOrigem");
      this.calculaDadosForm("", "paisOrigem");
      this.calculaDadosForm("", "ufDestino");
      this.calculaDadosForm("", "paisDestino");
      this.calculaDadosForm("", "zfm");
    },
    // ZERA VALOR DE ZFM
    reiniciaDependenciasEstado() {
      this.calculaDadosForm("", "zfm");
    },
    // ESCREVE OS VALORES DOS INPUTS DE ACORDO COM O FORMULÁRIO
    carregaDadosForm() {
      let dados = [
        { valor: "tipoOperacao", filtro: this.tipoOperacaoOptions },
        { valor: "ufOrigem", filtro: this.filtros.estado_origem.valores },
        { valor: "paisOrigem", filtro: this.filtros.pais_origem.valores },
        { valor: "ufDestino", filtro: this.filtros.estado_destino.valores },
        { valor: "paisDestino", filtro: this.filtros.pais_destino.valores },
        { valor: "zfm", filtro: this.zfmOptions }
      ];
      dados.forEach(p => {
        this.carregaValor(p.valor, p.filtro);
      });
    },
    // FUNÇÃO CHAMADA PARA ESCREVER OS VALORES LOCAIS
    carregaValor(valor, filtro) {
      let resultado = filtro.find(p => p.value == this.dadosForm[valor]);
      this[valor] = resultado ? resultado.label : "";
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-family: "Open Sans";
  font-weight: bold;
  font-size: 11px;
  text-transform: uppercase;
  color: #9ea2a7;
  span {
    color: red;
  }
}
.cenario-container {
  margin: 0.5rem 0;
}

.cenario-bloco {
  margin-top: 10px;
}
.zfm-input {
  width: 140px;
}
.question {
  color: #666;
  height: 13px;
}
.btn-question {
  margin-left: 5px;
  font-size: 13px;
}
</style>
